<template lang="pug">
  .flow-builder-image-template
    template-tools(v-if="!disabled", @delete="$emit('delete')")
    .template-platforms-container.badges.mb-3(v-if="disabled")
      b-badge(v-for="(platform, platform_index) in selectedPlatformsObjects.slice(0, sliceEnd)", :key="platform.platform_id", :style="{'background-color': platformColor(platform.name, 0.7)}") {{ platform.title }}
      b-badge(v-if="selectedPlatformsObjects.slice(sliceEnd).length", variant="soft-secondary") {{ selectedPlatformsObjects.slice(sliceEnd).length }} más
    .template-platforms-container.overflow-x.no-wrap.mb-3(v-else)
      b-form-group
        label.text-help.text-sm Plataformas donde se usará este template:
        k-select.disabled-white.flush(placeholder="- Agregar plataformas -", :options="parsedPlatforms", :disabled="disabled", :value="selected_platforms", @input="updatePlatforms", multiple, :limit="3", :searchable="false")
    image-component(v-for="(t_a, t_a_index) in Template_Attributes", :key="t_a.template_attribute_id", v-if="t_a.name == 'image'", :src="t_a.value", @input="updateTemplateAttribute(t_a, $event)", :disabled="disabled")
</template>

<script>
import templateCommon from '@/helpers/template-common'
import ImageComponent from '@/components/templates/common/Image.vue'
import TemplateTools from '@/components/templates/common/Tools.vue'
import _debounce from 'lodash.debounce'

export default {
  mixins: [templateCommon],
  components: {
    ImageComponent,
    TemplateTools
  },
  created () {
    this.updateTemplateAttribute = _debounce((template_attribute, value) => {
      let attribute = JSON.parse(JSON.stringify(template_attribute))
      attribute.value = value
      this.updateAttribute(this.block_id, this.template_id, attribute)
    }, 1000, { leading: false, trailing: true })
  },
}
</script>

<style lang="scss" scoped>
  @import '@/assets/colors.scss';

  .flow-builder-image-template {
    display: block;
    width: 100%;
    max-width: 100%;
    background-color: transparent;
    white-space: normal;
    position: relative;

    &:not(:last-child) {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
</style>
